<template>
  <div >
    
    <div style="padding: 10px 0">
      <vxe-grid
        ref="xGrid"
        auto-resize
        v-bind="gridOptions"
        @edit-disabled="editDisabledEvent"
        @cell-dblclick="noEdit"
      ></vxe-grid>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [
          {
            field: "entryCode",
            title: this.$t("message.table.number_"),
          },
          {
            field: "entryValue",
            title: this.$t("message.table.name"),
          },
          {
            field: "description",
            title: this.$t("message.table.address"),
          },
        ],
        data: [],
        
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
    };
  },
  props: ["listUsed"],
  methods: {
    removeCheckbox() {},
    editDisabledEvent() {},
    noEdit({ row }) {},
    getListInfo(){
      axios.get('/pmdm/admin/list/getListEntries?listId=' + this.$store.state.listId)
				.then( (res) => {
					console.log(res);
					if (res.data.code == 200) {
						this.gridOptions.data = res.data.object.listEntries;
					}
				})
    },
  },
  created(){
    this.getListInfo()
  }
};
</script>

<style scoped>
.btn {
  display: inline-block;
  padding: 4px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}
.btn span {
  position: relative;
  padding: 0 2px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn1 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
  margin-left: 20px;
}

.btn1:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn2 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn2:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 57px;
}

.content-title li {
  float: left;
  padding: 18px 12px 12px 12px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.btn7 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn8 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}
</style>

